@if (isProcessing()) {
  <aux-table-skeleton />
} @else {
  <ag-grid-angular
    class="ag-theme-aux site-cost-summary-table h-[calc(100vh-100px)] w-full tabular-nums"
    [gridOptions]="gridOptions()"
    [rowData]="gridData()"
    (gridReady)="onGridReady($event)"
  />
}
